import React from "react";
import { Link } from "react-router-dom";
import "../../../styles/VhdDashboard.scss";

export default function VHDCardComponent(props) {
  return (
    <div className="card card-vhd-data">
      <div className="card-body-data">
        <Link className="link-url" to={props.linkUrl}>
          <div className="card-row">
            <div className="vhd-card-img">{props.cardIcon}</div>
            <div className="divider-line"></div>
            <div className="vhd-card-right-data">
              <div className="vhd-card">
                <div className="card-head">{props.cardHeading}</div>
                <div className="card-data">{props.cardData}</div>
              </div>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
